// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1EwT6","title":"card_title__10xS-","inActive":"card_inActive__20B3a"};